var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 18.5c-3.59 0-6.5-2.91-6.5-6.5a.75.75 0 0 0-.75-.75A.75.75 0 0 0 4 12a8 8 0 0 0 8 8 8 8 0 0 0 8-8 .75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75c0 3.59-2.91 6.5-6.5 6.5M8.2 7.74a.747.747 0 0 0 .04 1.06.747.747 0 0 0 1.06-.04l1.95-2.1v7.59c0 .416.334.75.75.75s.75-.334.75-.75V6.66l1.95 2.1a.75.75 0 0 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0z"
  })));
};
export default SvgUploadIcon;